<template>
  <div id="level-navigation" class="level-navigation hide-for-print">
    <nav class="nav level-navigation__nav">

      <ul class="nav__navigation" v-if="!isFetching">
        <li class="nav__navigation__item first"><router-link :to="{ name: this.rout ? 'covid-19-monitor' : 'democracy-indices' }">{{ this.$Strings('worldmap') }}</router-link></li>
        <li v-if="!$store.state.covid19.is_enabled" class="nav__navigation__item"><router-link :to="{ name: 'compare-attributes' }">{{ this.$Strings('compareAttributes') }}</router-link></li>
        <li v-if="!$store.state.covid19.is_enabled" class="nav__navigation__item"><router-link :to="{ name: 'compare-countries-regions' }">{{ this.$Strings('compareCountryRegions') }}</router-link></li>
        <li class="nav__navigation__item last"><router-link :to="{ name: 'countries-regions-profile', query:{ 'covid19': $store.state.covid19.is_enabled ? '1' : '0' } }">{{ this.$Strings('countryProfile') }}</router-link></li>
      </ul>
      <ul class="nav__navigation" v-else>
        <li class="nav__navigation__item first"><a href="#" class="not-active">{{ this.$Strings('worldmap') }}</a></li>
        <li v-if="!$store.state.covid19.is_enabled" class="nav__navigation__item"><a href="#" class="not-active">{{ this.$Strings('compareAttributes') }}</a></li>
        <li v-if="!$store.state.covid19.is_enabled" class="nav__navigation__item"><a href="#" class="not-active">{{ this.$Strings('compareCountryRegions') }}</a></li>
        <li class="nav__navigation__item last"><a href="#" class="not-active">{{ this.$Strings('countryProfile') }}</a></li>
      </ul>
    </nav>
  </div><!-- /.page-navigation -->
</template>

<script>

  export default {
    name: 'level-navigation',
    props: ['rout'],
    computed: {
      isFetching () {
        return this.$store.state.fetching.length > 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .level-navigation{
    background: $gray-lightest;
    display: flex; -js-display: flex;
    flex-wrap: nowrap;
    position: relative;
    z-index: 151;
  }

  .level-navigation__nav{
    flex: 1 1 auto;
    width: 100%;
  }
  .level-navigation__selector{
    padding: 11px 20px;
  }


  .nav{}

  .nav__navigation{
    display: flex; -js-display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
    max-width: 900px;
    width: 100%;
  }

  .nav__navigation__item{
    display: inline-block;
    flex: 1 1 auto;
    text-align: center;

    a{
      color: $gray;
      display: inline-block;
      font-weight: 600;
      line-height: 1;
      padding: 20px 0;
      text-decoration: none;
      width: 100%;

      @media (max-width: 1100px) {
        font-size: 13px;
      }
    }

    a:hover{
      background: $gray-lighter;
      border-bottom: 3px solid $gray-lighter;
      color: $gray-darkest;
      padding-bottom: 20px - 3px;
    }

    a.router-link-active{
      border-bottom: 3px solid $gray-darkest;
      color: $gray-darkest;
      padding-bottom: 20px - 3px;
    }

  }
  .nav__navigation__item.first{
    max-width: 144px;
  }
  .nav__navigation__item.last{
    max-width: 222px;
  }
  .not-active {
    pointer-events: none;
    cursor: default;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/LevelNavigation.vue